import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InputColor } from 'src/app/interfaces/ui.theme';

type ChipVariant = 'Tag' | 'Default';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
})
export class ChipComponent {
  @Input() label: string = '';
  @Input() removable: boolean = false;
  @Input() compact: boolean = false;
  @Input() color!: InputColor;
  @Input() startIcon!: string;
  @Input() endIconClass!: string;
  @Input() variant: ChipVariant = 'Default';
  @Input() isClickable: boolean = false;
  @Input() isSelected: boolean = false;

  @Output() sendRemove = new EventEmitter();
  @Output() sendClick = new EventEmitter();

  refreshTypographyComponent: boolean = false;

  colorClass = {
    error: 'text-red-800 border-red-500 focus:border-red-500 bg-red-300',
    success:
      'text-green-800 border-green-500 focus:border-green-500 bg-green-300',
    warning:
      'text-yellow-800 border-yellow-500 focus:border-yellow-500 bg-yellow-300',
  };

  ngOnChanges() {
    if (this.isClickable) {
      this.refreshTypographyComponent = true;
      setTimeout(() => {
        this.refreshTypographyComponent = false;
      }, 1)
    };
  }

  onRemove(event: MouseEvent) {
    this.sendRemove.emit(event);
    event.stopPropagation();
  }

  onClick(event: MouseEvent) {
    this.sendClick.emit(event);
  }
}
